export class ExternalParameters {
    name: string;
    return: string;
    properties: string[] = [];
    rights: string[] = [];
}
